<template>
  <div class="basket-kit-modal">
    <ModalAsideHeader>
      {{ title }}
    </ModalAsideHeader>
    <ModalAsideBody>
      <div class="kit-modal">
        <div class="kit-modal__block">
          <BasketBoxModalSlider :result="state.product" />
        </div>
        <BasketKitDescription :result="state" @changeSize="handlerChangeSize" />
      </div>
      <BasketKitsModalSlider
        :kits-tabs="state.kitsTabs"
        :active-product="state.product"
        @changeProduct="handlerChangeProduct"
        @changeActiveTab="changeActiveTab"
      />
    </ModalAsideBody>
  </div>
</template>

<script lang="ts" setup>
import { computed, defineProps, reactive, onMounted } from 'vue';
import { IProduct } from '@/interfaces/IProduct/IProduct';
import { IMessages } from '@/interfaces/IMessages';
import BasketKitDescription from '@components/Basket/BasketKits/BasketKitDescription.vue';
import { useStore } from '@/store';
import axios from 'axios';
import ModalAsideHeader from '@use/useModalAside/ModalAsideHeader.vue';
import BasketKitsModalSlider from '@components/Basket/BasketKits/BasketKitsModalSlider.vue';

import { IKitsTabs } from '@components/Basket/BasketKits/IKitsTabs';
import BasketBoxModalSlider from '@components/Basket/BasketBox/BasketBoxModal/BasketBoxModalSlider.vue';
import Analytics from '@/utils/Analytics';
import ModalAsideBody from '@use/useModalAside/ModalAsideBody.vue';

interface IState {
  product: IProduct;
  messages: IMessages;
  kitsTabs: IKitsTabs;
}

const store = useStore();

const title = computed(() => store.state.basket.data.messages.kitsTitle);

const props = defineProps<{ result: IState; kitsTabs: IKitsTabs }>();

const state: IState = reactive({
  product: { ...props.result.product },
  messages: { ...props.result.messages },
  kitsTabs: JSON.parse(JSON.stringify(props.kitsTabs)),
});

const handlerChangeSize = async (url: string) => {
  try {
    store.commit('global/loaderStart');
    const { data, status }: { data: IState; status: number } = await axios.get(url, {
      params: { api: 'y' },
    });

    if (status !== 200) {
      throw `bad request response ${url}?api=y \n status: ${status}`;
    }

    state.product = data.product;
    state.messages = data.messages;
  } catch (err) {
    console.error(err);
  } finally {
    store.commit('global/loaderStop');
  }
};

const handlerChangeProduct = async (product) => {
  try {
    store.commit('global/loaderStart');
    const { data } = await axios.get(product.detailPage, { params: { api: 'y' } });

    state.product = data.product;
    state.messages = data.messages;
    Analytics.viewDetailProduct(data.product);
  } catch (err) {
    console.error(err);
  } finally {
    store.commit('global/loaderStop');
  }
};

const changeActiveTab = (i) => {
  state.kitsTabs = state.kitsTabs.map((el, key) => ({
    ...el,
    active: i === key,
  }));
};

onMounted(() => {
  Analytics.viewDetailProduct(state.product);
});
</script>

<style lang="scss" scoped>
.basket-kit-modal {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  :deep(.def-slider__next) {
    right: 0;
  }
  :deep(.def-slider__prev) {
    left: 0;
  }
  :deep(.modal-aside-header) {
    margin-bottom: 24px;
  }
}
.kit-modal {
  display: grid;
  grid-row-gap: 24px;
  grid-template-columns: minmax(0, 1fr);
  @include point-md {
    grid-template-columns: minmax(0, 1.1fr) minmax(0, 0.8fr);
    grid-column-gap: 63px;
  }
  &__block {
    display: flex;
    flex-direction: column;
  }
}
</style>
